import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPacks(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/generator/packs', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPackDetails(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/generator/packs/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadPack(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/generator/packs/${id}/download`, { responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPayments(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/generator/payments', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTransactions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/generator/transactions', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCustomPool(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/generator/packs/${id}/custom-pool`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    // Сверка имён артистов с БД: [{name, id|null, title|null}]
    matchArtists(ctx, { names }) {
      return new Promise((resolve, reject) => {
        axios
          .post('/generator/artists/match', { names })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
